import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserSessionService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  SEARCH_TRIPS_URL,
  TRIPS_REQUEST,
  UPCOMING_TRIPS_URL
} from '../constants/my-trip-constants';
import { CreditRequest, TravelReservation } from '../models/interface';
import { CreditCardSearchService } from '../services/credit-card-search.service';
@Injectable({
  providedIn: 'root'
})
export class CreditCardFacade {
  constructor(
    public search: CreditCardSearchService,
    public session: UserSessionService
  ) {}

  setSession(
    result: TravelReservation | HttpErrorResponse,
    fName: string,
    lName: string
  ): void {
    this.isSuccess(result)
      ? this.setSuccess(result, fName, lName)
      : this.setFailure(result);
  }

  isSuccess(
    result: TravelReservation | HttpErrorResponse
  ): result is TravelReservation {
    return 'travelReservations' in result;
  }

  getList(request: CreditRequest): void {
    this.search
      .getPNRList(request)
      .pipe(
        map((response) => response),
        catchError((error) => of(error as HttpErrorResponse))
      )
      .subscribe((trips) => {
        this.setSession(trips, request.fName, request.lName);
      });
  }

  setFailure = (result: HttpErrorResponse): void => {
    this.session.getUserSession().subscribe((data) => {
      if (Object.keys(data).length > 0 && data.loggedIn) {
        sessionStorage.setItem(
          TRIPS_REQUEST,
          JSON.stringify({
            error: true
          })
        );
        window.location.href = UPCOMING_TRIPS_URL;
      } else {
        window.location.href =
          SEARCH_TRIPS_URL +
          (result?.error?.errors ? result.error.errors[0].code : '');
      }
    });
  };

  setSuccess = (
    result: TravelReservation,
    fName: string,
    lName: string
  ): void => {
    const pnrList = result?.travelReservations?.map(
      (list) => list.reservation.bookingReferences[0].id
    );
    sessionStorage.setItem(
      TRIPS_REQUEST,
      JSON.stringify({
        list: pnrList,
        fName: fName,
        lName: lName,
        error: false
      })
    );
    window.location.href = UPCOMING_TRIPS_URL;
  };
}
